import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import BinaModal from '../../../ReactModal';
import { ensureProtocolInWebsiteUrl } from '../../../../utils/helpers';
import BridgeLink from '../../../../bridge/components/BridgeLink';
import { phoneWithInternationalCode } from '../../../../utils/helpers/common';

const ContactsModal = memo(({ phonesShown, isOpen, hide, residences }) => {
  const { t } = useTranslation();
  const phones = phonesShown?.map((phone, i) => {
    return (
      <a
        key={i}
        href={`tel:${phoneWithInternationalCode(phone)}`}
        className="contact-modal__numbers-i"
        data-stat="residence-phones"
      >
        {phone}
      </a>
    );
  });

  return (
    <BinaModal
      isOpen={isOpen}
      onRequestClose={hide}
      modalId="contacts"
      overlayClassName="modal__overlay-contacts"
      contentClassName="modal__content-contacts"
    >
      <div className="contact-modal__container">
        <div className="contact-modal__title">{t('residences.numbers')}</div>
        <div className="contact-modal__numbers">{phones}</div>
        {residences.contactEmail && (
          <a
            href={`mailto:${residences.contactEmail}`}
            className="contact-modal__email"
            data-stat="residence-email"
          >
            {residences.contactEmail}
          </a>
        )}
        {residences.website && (
          <BridgeLink
            href={ensureProtocolInWebsiteUrl(residences.website)}
            className="contact-modal__website"
            data-stat="residence-website"
          >
            {residences.website}
          </BridgeLink>
        )}
        <span
          className="contact-modal__close-btn"
          onClick={hide}
          onKeyPress={hide}
          role="button"
          tabIndex="-1"
        >
          ×
        </span>
      </div>
    </BinaModal>
  );
});

ContactsModal.displayName = `ContactsModal`;

ContactsModal.propTypes = {
  isOpen: PropTypes.bool,
  phonesShown: PropTypes.array,
  residences: PropTypes.object,
  hide: PropTypes.func
};

export default ContactsModal;
